module.exports = __webpack_public_path__ + "img/yuxiaowen.4ae13acb.jpg";